const Services = () => {
  const content = (
    <main>
      <section></section>
    </main>
  )
  return content
}

export default Services
